import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import bookmarkimg from "../../images/Icons/bookmark.png";
import placeImage from "../../images/placeholder.jpg";
import useLogout from "../Auth/useLogout";
import axios from "axios";
import config from "../../config";
import Dataloader from "../../Component/Dataloader";
import { toast } from "react-toastify";
import NoData from "../../Component/NoData";
import NumberFormatter from "../../Component/NumberFormatter";

export default function WatchList() {
  const [exist, setExist] = useState(true);
  const [loading, setLoading] = useState(false);
  const [productData, setProductData] = useState([]);
  const logout = useLogout();
  const fetchProduct = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${config.apiUrl}/bookmark`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: config.token,
          Accept: "application/json",
        },
      });
      setProductData(response.data.data);
    } catch (error) {
      if (error.response && error.response.status === 500) {
        setExist(false);
      }
      if (error.response && error.response.status === 401) {
        logout();
      }
    } finally {
      setLoading(false);
    }
  }, [logout]);

  useEffect(() => {
    fetchProduct();
  }, [fetchProduct]);

  const bookmark = async (event, cp_id, scp_id) => {
    event.preventDefault();
    try {
      const response = await axios.post(
        `${config.apiUrl}/bookmark`,
        { commodity_product_id: cp_id, seller_commodity_product_id: scp_id },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: config.token,
            Accept: "application/json",
          },
        }
      );

      setProductData((prevProduct) =>
        prevProduct.filter((data) => data.id !== scp_id)
      );

      toast.success(response.data.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } catch (error) {
      if (error.response && error.response.status === 401) {
        logout();
      }
    }
  };

  const imageOnError = (event) => {
    event.currentTarget.src = placeImage;
  };

  return (
    <>
      <div className="page-content">
        <div className="container-fluid">
          <div className="row-layout mrb1">
            {loading ? (
              <div className="d-flex justify-content-center">
                <Dataloader />
              </div>
            ) : (
              <>
                <div className="row-hd-txt">
                  <div className="row-hd-txt-left">
                    <img src={bookmarkimg} alt="icon" />
                    <h5>Watch List</h5>
                  </div>
                </div>
                <p className="order-note">
                  <span>Note - </span>
                  All the products added to your watch list are here. Keep an
                  eye on them for updates !
                </p>
                {productData.length > 0 && exist ? (
                  <div className="row g-3">
                    {productData.map((data, index) => (
                      <div className="col-lg-3 col-md-4 col-6 px-2" key={index}>
                        <div className="product-area">
                          <Link to={`/product-detail/${data.id}`}>
                            <div className="home-product">
                              <div className="product-image">
                                <img
                                  src={data.thumbnail}
                                  onError={imageOnError}
                                  alt="product"
                                />
                              </div>
                              <div className="row product-detail">
                                <div className="col-12">
                                  <h6
                                    className="one-line-clamp"
                                    style={{
                                      paddingTop: 0,
                                      borderTop: 0,
                                    }}
                                  >
                                    {data.name}
                                  </h6>
                                </div>
                                <div className="col-12">
                                  <div className="product-tag">
                                    <div>
                                      <span className="f-500">Brand:</span>
                                      <span>{data.brand}</span>
                                    </div>
                                    <div>
                                      <span className="f-500">Quality:</span>
                                      <span>
                                        {data.quality && data.quality.length > 0
                                          ? data.quality[0]
                                          : "--"}
                                      </span>
                                    </div>
                                    <div>
                                      <span className="f-500">Size:</span>
                                      <span>
                                        {data.default_variation &&
                                        data.default_variation[0]
                                          ? data.default_variation[0].value +
                                            " " +
                                            data.default_variation[0].unit
                                              .short_name
                                          : "--"}
                                      </span>
                                    </div>
                                    <div>
                                      <span className="f-500">Location:</span>
                                      <span>Ex-{data.city}</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="row rate-area">
                                <div className="col-12">
                                  <h6 className="p-0 border-0">
                                    Rs{" "}
                                    <NumberFormatter number={data.ex_price} />
                                    /MT
                                  </h6>
                                  <span>GST & other charges included</span>
                                </div>
                                <div className="col-12">
                                  <button className="price-statusup btn">
                                    Get Best Price
                                  </button>
                                </div>
                              </div>
                            </div>
                          </Link>
                          <div className="details-action-wishButton">
                            <div
                              className={`btn-wishlist ${
                                data.is_bookmarked && "active"
                              }`}
                              onClick={(e) =>
                                bookmark(e, data.commodity_product_id, data.id)
                              }
                              title="Watchlist"
                            >
                              <i className="bi bi-bookmark"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <NoData />
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
